<template>
  <div>
    <div id="accordionFilter" class="content">
      <div class="card">
        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
             data-parent="#accordionFilter">
          <div class="card-body">
            <el-form :inline="true" :model="filterForm" label-position="left" label-width="50px" size="small">
              <el-col :span="20">
                <el-form-item label="描述">
                    <el-input v-model="filterForm.filterString" placeholder="描述"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                    <el-button size="small" type="primary" :disabled="filterForm.filterString === ''" @click="searchBom">搜索</el-button>
                </el-form-item>
              </el-col>  
                
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div id="entityResultTable" class="content">
      <div class="card my-1">
        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
             data-parent="#accordionResult">
          <div class="card-body">
            <div class="el-tree-div">
              <el-tree ref="elBomTree" :data="treeData" :props="defaultProps" :load="loadNode" lazy  @node-click="handleNodeClick" node-key="id" empty-text="输入关键字搜索BOM">
            </el-tree>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-07-09 15:09:42

import emCommonModalMixin from "@/mixin/em/common/modal";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
  name: "emFilterElementTree",
  mixins: [emCommonModalMixin,emCommonApiMixin],
  // props: {
  //   treeData: {
  //     type: Array
  //   }
  // },
  data() {
    return {
      defaultProps: {
        children: "children",
        label(data,node) {
          return data.longText + ": " + data.component;
        },
        isLeaf: "leaf"
      },
      filterForm: {
        filterString:'',
      },
      treeData:[],
    }
  },
  computed: {
    treeNodes() {
      return this.$store.state[this.entity][this.loadState]
    }
  },
  methods: {
    nodeOnClick(event, treeId, treeNode, clickFlag) {
      this.$emit("onclick", event, treeId, treeNode, clickFlag);
    },
    filterDoClear(){
      this.$emit("doClear");
    },
    searchBom() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstBom")}/findBomByConditions`;
                let obj = new Object();
                obj.longTextFilter = self.filterForm.filterString;
                self.$_emApiMixin_post(url, obj)
                .then((response) => {
                    if(response.data instanceof Array) {
                        response.data.map(item => {
                        self.treeData.push(Object.assign({},item,{children:""}))
                    })
                    } 
                })
    },
    searchChildrenBoms(node,resolve) {
                let bomId = node.data.id;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstBom")}/findChildrenBomById?id=${bomId}`;
                this.$_emApiMixin_get(url, {})
                .then((response)=>{
                    if(response.length === 0) {
                        resolve([]);
                    } else {
                        resolve(response);
                    }
                    
                })
    },
    loadNode(node, resolve) {
                if(node.level === 0) {
                    resolve(this.treeData);
                } else {
                    setTimeout(()=>{
                        this.searchChildrenBoms(node,resolve);
                        // let res = this.searchChildrenBoms(node.data.id);
                        // resolve(res);
                    },500)
                }
    },
    handleNodeClick(node) {
      this.$emit("onNodeClick", node);
    }
  }
};
</script>

<style scoped>
.el-tree-div {
  height: 80vh;
  overflow: auto;
}
</style>